<template>
	<div class="impressum">
		<b-container class="mt-top text-left prl-outside">
		<b-row class="mb-3 top-text">{{$t('title')}}</b-row>

		<b-row class="prl-inside">
			<p><span style="font-weight:700">GERA – Montagen für Tischlereiprodukte GmbH</span><br>
			Mettersdorf 109<br>
			A-8092 Mettersdorf
			</p>	      
			<p>
			Tel: +43 (0) 3477/3445<br>
			Fax: +43 (0) 3477/3445 4<br>
			E-mail: <a href="mailto:office@gera.at">office@gera.at</a>
			</p>	    
			<p>{{$t('grccm')}}</p>  
			<p>{{$t('firmnumber')}}: 141380</p>
			<p>{{$t('manager')}}: Helmut Raggam</p>
			<p>{{$t('company')}} 500241887</p>
			<!--<p>{{$t('webdesign')}}: <a href="https://www.moerth.at/" target="_blank" rel="noopener">www.moerth.at</a></p>-->
			<p>{{$t('responsible')}} GERA Montagen</p>
			<p><span style="font-weight:700">{{$t('cr')}}:</span> {{$t('crText')}}</p>
			<p><span style="font-weight:700">{{$t('liability')}}:</span> {{$t('liabilityText')}}</p>
			<p><span style="font-weight:700">{{$t('links')}}:</span> {{$t('linksText')}}</p>
<!--			<p><span style="font-weight:700">{{$t('mkp')}}</span><br>
				Mörth & Mörth GmbH<br>
				{{$t('agency')}}<br>
				Lilienpark 2<br>
				8072 Fernitz
			</p>	      -->
<!--			<p>
			W: <a href="https://www.moerth.at/" target="_blank" rel="noopener">www.moerth.at</a><br>
			E: <a href="mailto:moerth@moerth.at">moerth@moerth.at</a>
			</p>	    -->
			<p>&copy; 2020 – {{$t('copyright')}}</p>
		</b-row>
		</b-container>
		<div class="big-text">{{$t('title')}}</div>
	</div>
</template>

<script>
export default {
	name: 'Impressum',
	data () {
		return {
		}
	}
}
</script>
<style scoped>
	p {
		width: 100%;
		font-size: 0.9rem;
}
</style>
<i18n>
	{
		"de": {
			"title": "Impressum",
			"grccm": "Landesgericht für ZRS Graz",
			"firmnumber": "Firmenbuchnummer",
			"manager": "Geschäftsführer",
			"company": "Wir sind ein HFU gelistetetes Unternehmen. Unsere Dienstgebernummer lautet:",
			"webdesign": "Webdesign",
			"responsible": "Für Inhalte verantwortlich:",
			"cr": "URHEBERRECHT",
			"crText": "Informationen auf dieser Website einschließlich Texten, Bildern und Sounds, dürfen nicht, sofern nicht ausdrücklich anders bestimmt, vervielfältigt, transferiert, vertrieben oder gespeichert werden ohne schriftliche Genehmigung des Herausgebers. Modifikationen des Inhalts dieser Website sind ausdrücklich untersagt.",
			"liability": "HAFTUNGSAUSSCHLUSS",
			"liabilityText": "Obwohl bei der Zusammenstellung der auf unseren Webseiten enthaltenen Informationen größte Sorgfalt angewandt wurde, können wir für die Aktualität, Richtigkeit oder Vollständigkeit keine Gewähr übernehmen. Haftungsansprüche gegen uns, die sich auf Schäden materieller oder ideeller Art beziehen, welche durch die Nutzung oder Nichtnutzung der dargebotenen Informationen oder durch fehlerhafte und unvollständige Informationen verursacht wurden, sind grundsätzlich ausgeschlossen. Wir behalten uns Änderungen der Informationen auf diesem Server ohne vorherige Ankündigung vor. Alle Angebote sind freibleibend und unverbindlich.",
			"links": "LINKS",
			"linksText": "Die Website enthält Links zu externen Websites. Da diese Websites nicht unserem Einfluss unterliegen, können wir keinerlei Verantwortung für deren Inhalte und Datenschutzpolitik übernehmen.",
			"mkp": "Marketing, Konzept und Programmierung",
			"agency": "Agentur für Werbung und Informationsdesign",
			"copyright": "Sämtliche Inhalte sind urheberrechtlich geschützt!"
		},
		"en": {
			"title": "Publishing information",
			"grccm": "Graz Regional Court for Civil Matters",
			"firmnumber": "Register of Companies number",
			"manager": "Managing director",
			"company": "We are a company listed on the list of companies exempt from liability. Our employer number is:",
			"webdesign": "Webdesign",
			"responsible": "Responsible for all content: ",
			"cr": "COPYRIGHT",
			"crText": "Information on this website including texts, images and sounds may not, unless explicitly specified elsewhere, be copied, transferred, sold or stored without written permission of the publisher. Modifications to the content of this website are expressly prohibited.",
			"liability": "DISCLAIMER OF LIABILITY",
			"liabilityText": "Although we used the greatest possible care when compiling the information contained on our website, we can assume no guarantee for the currentness, correctness or completeness thereof. Liability claims against us that are based on damage of a material or non-material nature that were caused by using or not using the presented information or by faulty and incomplete information are generally precluded. We reserve the right to change the information on this server without previous notification. All offers are subject to change and non-binding.",
			"links": "LINKS",
			"linksText": "The website contains links to external websites. Since those websites are not subject to our influence, we cannot assume any responsibility whatsoever for their contents and data protection policies.",
			"mkp": "Marketing, concept and programming",
			"agency": "Agency for advertising and information design",
			"copyright": "All contents are protected under copyright law!"
		}
	}
</i18n>
